import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Form } from 'element-ui';

declare var _hmt: any;
enum AccountType { Teacher = 'Teacher', SubAccount = 'SubAccount' }

@Component
export default class AccountListComponent extends Vue {
    @Prop({ required: true, default: AccountType.Teacher }) accountType: string;

    currentPage: number = 1;
    pageSize: number = 10;
    total: number = 10;
    listLoading: Boolean = false;
    commonList: any = [];
    isTeacher: Boolean = true;
    isAllot: boolean = false;//分配or召回
    allotList: any = [];
    groupList: Array<Object> = [];
    accountRestCount: number = 0;
    currAccountName: string = '';
    currRow: any = {}; //选中的当前行
    parentList: boolean = true;
    teacherInfoList: any = [];
    isDisable = false;//防止二次点击
    //弹出框
    dialogEditAllotTime: boolean = false;
    dialogRemark: boolean = false;
    dialogRealName: boolean = false;
    dialogShowAllotTime: boolean = false;
    dialogGroup: boolean = false;

    //备注表单
    remarkForm = {
        remark: '',
        accountId: ''
    }

    //姓名表单
    realNameForm = {
        realName: '',
        accountId: ''
    }

    //姓名表单 验证规则
    realNameFormRules: Object = {
        realName: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入姓名'));
                    } else if (!/^[\u4e00-\u9fa5]{2,10}$/.test(value)) {
                        callback(new Error('姓名为2-10位中文（无空格）'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    //备注表单 验证规则
    remarkFormRules: Object = {
        remark: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入备注'));
                    } else if (!/^[\S]{0,50}$/.test(value)) {
                        callback(new Error('备注为0-50位字符，中文，英文，数字及符号（无空格）'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    //分配召回表单
    allotTimeForm = {
        turnover: '',//用户输入余额
        subUserId: '',//userid
        showCount: '',//显示余额
        setType: true, //分配或召回
        message: '', //提示
        isShowMsg: false
    }

    //分配召回表单 验证规则
    allotTimeFormRules: object = {}

    //添加子账号/教师账号表单
    addChildAccountForm = {
        subUserId: '',
        password: '',
        realName: '',
        remarks: '',
        status: 1,
        groupId: '',
        groupName: '',
        allocateCount: null
    }

    //添加子账号/教师账号表单 验证规则
    addChildAccountFormRules: Object = {};

    //添加子账号/教师账号表单 验证规则 初始化
    initAddChildAccountFormRules() {
        this.addChildAccountFormRules = {
            subUserId: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入账号名称'));
                        } else if (!/^(?!_)(?=.*[A-Za-z])(?=.*\d)[\w]{4,16}$/.test(value)) {
                            callback(new Error('账户名为4-16位字符，至少包含一个数字或字母，且不能以下划线开头'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            password: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入初始密码'));
                        } else if (!/^[\w]{6,20}$/.test(value)) {
                            callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            realName: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入真实姓名'));
                        } else if (!/^[\u4e00-\u9fa5]{2,10}$/.test(value)) {
                            callback(new Error('姓名为2-10位中文（无空格）'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            remarks: [
                {
                    validator: (rule, value, callback) => {
                        if (!/^[^\s]{0,50}$/.test(value)) {
                            callback(new Error('备注为0-50位字符，中文，英文，数字及符号(无空格)'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            groupId: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请选择分组'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ],
            allocateCount: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === '') {
                            callback(new Error('请输入分配金额'));
                        } else if (!/^[1-9]*[1-9][0-9]*$/.test(value)) {
                            callback(new Error('分配金额为正整数'));
                        } else if (parseInt(value) > this.accountRestCount) {
                            callback(new Error('主账号剩余金额不足'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }
            ]
        }
    }

    //关联表单
    $refs: {
        allotTimeForm: Form,
        remarkForm: Form,
        addChildAccountForm: Form,
        realNameForm: Form,
    };


    //查询条件
    searchData = {
        sortBy: 0,//排序
        order: 1,//升序or降序
    }

    //pageSize触发事件
    handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        if (this.parentList) {
            this.getList();
        } else {
            this.getInfoList(this.currRow);
        }
    }

    //跳转页面触发事件
    handleCurrentChange(val) {
        this.currentPage = val;
        //this.getList();
        if (this.parentList) {
            this.getList();
        } else {
            this.getInfoList(this.currRow);
        }
    }

    //排序钩子
    sortObj = {
        sortBy: {
            createTime: 0,
            consumption: 1,
        },
        order: {
            ascending: 0,
            descending: 1
        }
    }

    //排序改变触发事件
    sortChange(val) {
        this.searchData.sortBy = this.sortObj.sortBy[val.prop];
        this.searchData.order = this.sortObj.order[val.order];
        this.currentPage = 1;
        this.getList();
    }

    //传递到父模块
    handleSelectionChange(val) {
        this.$emit('handleSelectionChange', val);
    }

    jumpInfo(row) {

        _hmt.push(['_trackEvent', '课程作业_子账号管理', '查看账号详情', '事件价值', 1]);

        this.currRow = row;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 10;
        if (this.isTeacher) {
            this.$router.push({
                path: '/studytasks',
                query: {
                    creator: row.subUserId
                }
            });
        } else {
            this.$emit('jumpTeachInfo', row);
        }
    }

    /**##############################修改姓名Begin##############################**/
    editRealName(row) {
        this.$refs['realNameForm'] && this.$refs['realNameForm'].resetFields();
        this.realNameForm.realName = row.realName;
        this.realNameForm.accountId = row.subUserId;
        this.dialogRealName = true;
    }

    onRealNameSubmit() {
        let id = this.realNameForm.accountId;
        let content: string = this.realNameForm.realName;
        content = encodeURIComponent(content);
        this.$refs.realNameForm.validate((valid) => {
            if (valid) {
                this.axios.put('/api/Accounts/updateusername/' + id + '?userName=' + content).then((data) => {
                    this.dialogRealName = false;
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });

                    this.getList();
                });
            }
        });
    }

    /**##############################修改备注Begin##############################**/
    editRemark(row) {
        this.$refs['remarkForm'] && this.$refs['remarkForm'].resetFields();
        this.remarkForm.remark = row.remarks;
        this.remarkForm.accountId = row.subUserId;
        this.dialogRemark = true;
    }
    onRemarkSubmit() {
        let id = this.remarkForm.accountId;
        let content: string = this.remarkForm.remark;
        content = encodeURIComponent(content);
        this.$refs.remarkForm.validate((valid) => {
            if (valid) {
                this.axios.put('/api/accounts/remark/' + id + '?remark=' + content).then((data) => {
                    this.dialogRemark = false;
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });

                    this.getList();
                });
            }
        });
    }
    /**##############################修改备注End##############################**/


    /**##############################修改分组Begin##############################**/
    editGroupId: any = '';
    accountId: any = '';
    teachGroupList: Array<Object> = [];

    //修改分组
    editGroup(row) {


        this.editGroupId = row.groupId;
        this.accountId = row.subUserId;
        this.axios.get('/api/groups/').then((data) => {

            this.teachGroupList = data.data;
            this.dialogGroup = true;
        })
    }

    //提交修改
    onGroupSubmit() {
        let id = this.accountId;
        let groupid: number = this.editGroupId;

        this.axios.put('/api/accounts/group/' + id + ' ?groupId=' + groupid).then((data) => {
            this.dialogGroup = false;
            this.$message({
                message: '提交成功',
                type: 'success'
            });
            this.getList('Teacher');
        });
    }
    /**##############################修改分组End##############################**/


    /**##############################添加子账号Begin##############################**/
    dialogChildAccount: Boolean = false;

    onAddAccountSubmit() {

        this.$refs.addChildAccountForm.validate((valid) => {
            if (valid) {

                let model = (<any>Object).assign({}, this.addChildAccountForm);
                model.accountType = this.accountType;
                model.subUserId = this.currAccountName + '.' + model.subUserId;
                let para = [];
                para.push(model);

                this.isDisable = true;
                this.axios({
                    method: 'post',
                    url: '/api/accounts/accountName/' + model.subUserId,
                    transformResponse: [(data) => {
                        // 对 data 进行任意转换处理
                        if (data) {

                        }
                    }],
                    validateStatus: (status) => {
                        if (status == 412) {
                            this.isDisable = false;
                            this.$message({
                                message: '账号名称已存在',
                                type: 'error'
                            });

                        } else if (status == 200) {
                            this.axios.post('/api/accounts?mark=' + this.accountType, para).then((data) => {
                                this.isDisable = false;
                                if (data.data.stateCode == undefined) {
                                    if (data.data['errorUsers'] == '' && data.data['exsitUsers'] != '') {
                                        this.$message({
                                            message: data.data['exsitUsers'] + '用户名已存在',
                                            type: 'error'
                                        });
                                    } else if (data.data['errorUsers'] != '') {
                                        this.$message({
                                            message: '添加失败',
                                            type: 'error'
                                        });
                                    } else {
                                        this.$message({
                                            message: '提交成功',
                                            type: 'success'
                                        });
                                        this.dialogChildAccount = false;
                                        this.getList();
                                        this.$refs['addChildAccountForm'].resetFields();
                                    }
                                }else if (data.data.stateCode == '412') {
                                    this.$message({
                                        message: data.data.message,
                                        type: 'error'
                                    });
                                } else {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success'
                                    });
                                    this.dialogChildAccount = false;
                                    this.getList();
                                    this.$refs['addChildAccountForm'].resetFields();
                                }
                            })
                        }
                    },
                });
                //this.axios.post('/api/accounts/accountName/' + model.subUserId).then(data => {
                //    if (data == undefined) {
                //        this.$message({
                //            message: '提交失败',
                //            type: 'error'
                //        });
                //        this.isDisable = false;
                //    } else if (data.data.stateCode == '412') {
                //        this.$message({
                //            message: data.data.message,
                //            type: 'error'
                //        });
                //        this.isDisable = false;
                //    } else if (data.status == 200 && data.data == "") {
                //        this.axios.post('/api/accounts?mark=' + this.accountType, para).then((data) => {
                //            this.isDisable = false;
                //            if (data.data.stateCode == '412') {
                //                this.$message({
                //                    message: data.data.message,
                //                    type: 'error'
                //                });
                //            } else {
                //                this.$message({
                //                    message: '提交成功',
                //                    type: 'success'
                //                });
                //                this.dialogChildAccount = false;
                //                this.getList();
                //                this.$refs['addChildAccountForm'].resetFields();
                //            }
                //        })
                //    }
                //})
            }
        })
    }

    onResetAccount() {
        this.$refs['addChildAccountForm'].resetFields();
    }

    addAccount() {
        this.dialogChildAccount = true;
        this.getAccountInfo();
        this.$refs['addChildAccountForm'] && this.$refs['addChildAccountForm'].resetFields();
    }
    /**##############################添加子账号End##############################**/

    //查看累计分配余额
    showAllotTime(row) {

        if (this.accountType == AccountType.Teacher) {
            _hmt.push(['_trackEvent', '课程作业_教师账号管理', '查看明细', '事件价值', 1]);
        } else {
            _hmt.push(['_trackEvent', '课程作业_子账号管理', '查看明细', '事件价值', 1]);
        }

        let accountId = row.subUserId;
        this.dialogShowAllotTime = true;

        this.axios.get('/api/accounts/getAllocateCount?userId=' + accountId).then((data) => {

            this.allotList = data.data;
        });
    }

    //修改分配/召回余额
    editAllotTime(row) {

        if (this.accountType == AccountType.Teacher) {
            _hmt.push(['_trackEvent', '课程作业_教师账号管理', '分配/召回功能', '事件价值', 1]);
        } else {
            _hmt.push(['_trackEvent', '课程作业_子账号管理', '分配/召回功能', '事件价值', 1]);
        }
        
        row.accountId;
    }

    initAllotTimeForm() {
        this.allotTimeForm = {
            turnover: '',//用户输入余额
            subUserId: '',//userid
            showCount: '',//显示余额
            setType: true, //分配或召回
            message: '', //提示
            isShowMsg: false
        }
    }

    onEditAllotTimeSubmit() {

        if (!/^[1-9]\d*$/.test(this.allotTimeForm.turnover.toString()) || this.allotTimeForm.turnover == '0' || this.allotTimeForm.turnover == '') {
            this.allotTimeForm.message = '请输入正确的正整数';
            this.allotTimeForm.isShowMsg = true;
            return;
        }

        if (parseInt(this.allotTimeForm.turnover) > parseInt(this.allotTimeForm.showCount)) {
            //TODO 提示msg 请正确输入/主账号剩余余额不足
            if (this.allotTimeForm.setType) {
                this.allotTimeForm.message = '主账号剩余金额不足';
            } else {
                this.allotTimeForm.message = '子账号剩余金额不足';
            }
            this.allotTimeForm.isShowMsg = true;

            return;
        }


        let para = {
            subUserId: this.allotTimeForm.subUserId,
            turnover: this.allotTimeForm.turnover,
            setType: this.allotTimeForm.setType
        }
        let options = {
            params: para
        };
        this.isDisable = true;
        this.axios.get('/api/accounts/SetCheckCount', options).then((data) => {
            this.$message({
                message: '提交成功',
                type: 'success'
            });
            this.dialogEditAllotTime = false;
            this.isDisable = false;
            this.getList();
            //TODO 修改完剩余余额，更新当前row
        });
    }

    onEditAllotTime(row, flag) {

       
        this.$refs['allotTimeForm'] && this.$refs['allotTimeForm'].resetFields();
        this.initAllotTimeForm();
        this.allotTimeForm.subUserId = row.subUserId;
        this.allotTimeForm.setType = flag;
        if (flag) {
            this.getAccountInfo(flag);
            //this.allotTimeForm.showCount = this.accountRestCount.toString();
        } else {
            this.allotTimeForm.showCount = row.restCount;
        }
        this.isAllot = flag;
        this.dialogEditAllotTime = true;
    }

    getInfoList(row, jump?) {

        this.currentPage = jump ? 1 : this.currentPage;
        let para: object = {
            limit: this.pageSize,
            mark: AccountType.Teacher,
            subUserId: row.subUserId,
            offset : (this.currentPage - 1) * this.pageSize
        };
       
        let options = {
            params: para
        };

        this.axios.get('/api/accounts', options).then((data) => {

            let result = data.data;
            this.total = result.total;
            this.teacherInfoList = result.data;
            this.parentList = false;
        }).catch(function (error) {
            console.log(error)
        });
    }

    getList(markType?, jump?) {
        this.currentPage = jump ? 1 : this.currentPage;
        this.parentList = true;
        this.listLoading = true;
        this.commonList = [];
        this.pageSize = markType ? 10 : this.pageSize;
        let para = (<any>Object).assign({}, this.searchData);
        para.offset = (this.currentPage - 1) * this.pageSize;

        para.limit = this.pageSize;
        para.mark = markType || this.accountType;
        para.timestamp = new Date().getTime();

        this.isTeacher = para.mark == AccountType.Teacher;

        let options = {
            params: para
        };

        this.axios.get('/api/accounts', options).then((data) => {

            if (!data) {
                this.total = 0;
                this.commonList = [];
                return;
            };

            this.listLoading = false;
            let result = data.data;
            this.total = result.total;
            this.commonList = result.data;
        }).catch(function (error) {
            console.log(error)
        });


    }

    getGroupList() {
        this.axios.get('/api/groups').then((data) => {
            this.groupList = data.data;
            if (data.data && data.data.length > 0) {
                this.addChildAccountForm.groupId = data.data[0].groupId
            }
            
        })
    }

    getAccountInfo(flag?) {
        this.axios.get('/api/accounts/GetAccountInfo').then((data) => {
            if (data.status == 200) {
                let result = data.data;
                this.currAccountName = result.userId;
                this.accountRestCount = result.balance;
                if (flag) {
                    this.allotTimeForm.showCount = this.accountRestCount.toString();
                }
            }
        })
    }

    initFromRuleAndAccountInfo() {
        this.axios.get('/api/accounts/GetAccountInfo?timestamp=' + new Date().getTime()).then((data) => {
            if (data.status == 200) {
                let result = data.data;
                this.currAccountName = result.userId;
                this.accountRestCount = result.balance;
                this.initAddChildAccountFormRules();
            }
        })
    }

    mounted() {
        this.getList();
        this.initFromRuleAndAccountInfo();

        if (this.accountType == AccountType.Teacher) {
            this.getGroupList();
        }
    }
}